export const env = {
  "SUDO_GID": "0",
  "VIDEO_JS_LICENSE": "100f5a560149555612",
  "STAGE_UPPY_COMPANION_URL": "https://companion.stage.thkee.dev",
  "USER": "buildbot",
  "npm_config_user_agent": "npm/9.6.6 node/v20.2.0 linux x64 workspaces/false",
  "CI": "true",
  "CF_PAGES_COMMIT_SHA": "1dcfb0dde96e935ba651d1db85c56c4048ae47b5",
  "ROOT_DIR": "/",
  "npm_node_execpath": "/opt/buildhome/.asdf/installs/nodejs/20.2.0/bin/node",
  "SHLVL": "1",
  "FIREBASE_MESSAGING_SENDER_ID": "628299107846",
  "LOG_ROCKET_ENABLED": "true",
  "npm_config_noproxy": "",
  "QA_SERVER_URL": "https://qa.check.thkee.dev",
  "HOME": "/opt/buildhome",
  "QA_BASE_URL_WEBSOCKET": "qa.check.thkee.dev",
  "npm_package_json": "/opt/buildhome/repo/package.json",
  "STAGE_TAP_PUBLIC_KEY": "pk_live_C08hpsX9wMnW4N5xaz6jiHJO",
  "NODE_OPTIONS": "--max_old_space_size=4096",
  "npm_config_userconfig": "/opt/buildhome/.npmrc",
  "npm_config_local_prefix": "/opt/buildhome/repo",
  "PKG_EXECPATH": "/opt/build/bin/build",
  "STAGE_HOME_URL": "https://stage.thkee.dev",
  "COLOR": "0",
  "CF_PAGES_BRANCH": "update/SA-1779-new-course-creation-ux",
  "npm_config_metrics_registry": "https://registry.npmjs.org/",
  "SUDO_UID": "0",
  "LOGNAME": "buildbot",
  "SITE_KEY": "0x4AAAAAAABUtlO8-1LJhFyQ",
  "QA_UPPY_COMPANION_URL": "https://qa.comp.thkee.dev",
  "npm_config_prefix": "/opt/buildhome/.asdf/installs/nodejs/20.2.0",
  "npm_config_npm_version": "9.9.3",
  "DEFAULT_LANGUAGE": "ar-SA",
  "TERM": "unknown",
  "npm_config_cache": "/opt/buildhome/.npm",
  "GOOGLE_CLIENT_ID": "1085924331203-k5rr1nanteeo77el8pf6ul0noue93o15.apps.googleusercontent.com",
  "FIREBASE_STORAGE_BUCKET": "thkee-qa.firebasestorage.app",
  "FIREBASE_AUTH_DOMAIN": "thkee-qa.firebaseapp.com",
  "npm_config_node_gyp": "/opt/buildhome/repo/node_modules/npm/node_modules/node-gyp/bin/node-gyp.js",
  "PATH": "/opt/buildhome/repo/node_modules/.bin:/opt/buildhome/node_modules/.bin:/opt/node_modules/.bin:/node_modules/.bin:/opt/buildhome/repo/node_modules/npm/node_modules/@npmcli/run-script/lib/node-gyp-bin:/opt/buildhome/repo/node_modules/.bin:/opt/buildhome/node_modules/.bin:/opt/node_modules/.bin:/node_modules/.bin:/opt/buildhome/repo/node_modules/npm/node_modules/@npmcli/run-script/lib/node-gyp-bin:/opt/buildhome/repo/node_modules/.bin:/opt/buildhome/node_modules/.bin:/opt/node_modules/.bin:/node_modules/.bin:/opt/buildhome/.asdf/installs/nodejs/20.2.0/lib/node_modules/npm/node_modules/@npmcli/run-script/lib/node-gyp-bin:/opt/buildhome/.asdf/plugins/nodejs/shims:/opt/buildhome/.asdf/installs/nodejs/20.2.0/bin:/opt/buildhome/.asdf/shims:/opt/buildhome/.asdf/bin:/opt/buildhome/.swiftenv/bin:/opt/buildhome/.swiftenv/shims:/opt/buildhome/.php:/opt/buildhome/.binrc/bin:/usr/local/rvm/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/opt/buildhome/.cask/bin:/opt/buildhome/.gimme/bin:/opt/buildhome/.dotnet/tools:/opt/buildhome/.dotnet:/opt/buildhome/.local/bin",
  "CF_PAGES_URL": "https://fd5f71e6.angelpath.pages.dev",
  "NODE": "/opt/buildhome/.asdf/installs/nodejs/20.2.0/bin/node",
  "npm_package_name": "thkee-app",
  "QA_TAP_PUBLIC_KEY": "pk_test_q6Odm4txscnSGBMje3hYoPC5",
  "npm_lifecycle_script": "node -e \"const fs = require('fs'); const env = { ...process.env, npm_package_version: require('./package.json').version }; fs.writeFileSync('./projects/thkee-marketplace-app/src/environments/.env.ts', 'export const env = ' + JSON.stringify(env, null, 2) + ';')\"",
  "npm_config_loglevel": "silent",
  "SUDO_COMMAND": "/opt/build/bin/build npm run build",
  "SHELL": "/bin/bash",
  "QA_HOME_URL": "https://qas.thkee.dev",
  "npm_package_version": "0.9.1",
  "npm_lifecycle_event": "env-marketplace",
  "FIREBASE_PROJECT_ID": "thkee-qa",
  "REPO_DIR": "/opt/buildhome/repo",
  "SUDO_USER": "root",
  "STAGE_SERVER_URL": "https://api.stage.thkee.dev",
  "FIREBASE_APP_ID": "1:628299107846:web:1a068e47156b0a52a93d87",
  "STAGE_BASE_URL_WEBSOCKET": "api.stage.thkee.dev",
  "GEOLOCATION_URL": "https://geolocation.thkee.com",
  "npm_config_globalconfig": "/opt/buildhome/.asdf/installs/nodejs/20.2.0/etc/npmrc",
  "npm_config_init_module": "/opt/buildhome/.npm-init.js",
  "PWD": "/opt/buildhome/repo",
  "npm_execpath": "/opt/buildhome/repo/node_modules/npm/bin/npm-cli.js",
  "THK_COOKIE_DOMAIN": ".thkee.dev",
  "CF_PAGES": "1",
  "npm_config_global_prefix": "/opt/buildhome/.asdf/installs/nodejs/20.2.0",
  "npm_command": "run-script",
  "BUILD_ENV": "dev-MF",
  "NODE_ENV": "staging",
  "FIREBASE_API_KEY": "AIzaSyCDGeitXmkuTwGKggtLrg1O9NHXZEaH4aQ",
  "INIT_CWD": "/opt/buildhome/repo",
  "EDITOR": "vi"
};